import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-5" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg md:text-xl mb-1 mr-4" }, "Stocks", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "This project at its current state is a simple stock screener that returns some information about a stock given a ticker name. The goal for this project is to evolve into complex system with the following functionalities:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("ul", { class: "list-disc list-inside my-1" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Create portfolios of different stocks"),
  /*#__PURE__*/_createElementVNode("li", null, "Review a set of technical and fundamental indicators of a stock or a set of stocks"),
  /*#__PURE__*/_createElementVNode("li", null, "Create algorithmic trading strategies based on different variables"),
  /*#__PURE__*/_createElementVNode("li", null, "Forward and backtest algorithmic trading strategies")
], -1)
const _hoisted_6 = { class: "mt-5" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg md:text-xl mb-1 mr-4" }, "Data", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "This is rather an aggregate set of mini projects related to data that I am working on. Some of data crawling and analysis work are showcased in the project page. The different mini data projects have various purposes such as:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("ul", { class: "list-disc list-inside my-1" }, [
  /*#__PURE__*/_createElementVNode("li", null, "gathering intel for potential investments"),
  /*#__PURE__*/_createElementVNode("li", null, "data annotation with goals of training/experimenting with ML algorithms")
], -1)
const _hoisted_11 = { class: "mt-5" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg md:text-xl mb-1 mr-4" }, "Embark", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "This project at its current state allows a user to research and create a travel plan, and to save and share travel plans to other people. This project extensively uses Google Maps API both in the frontend and backend.", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "mt-5" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-lg md:text-xl mb-1 mr-4" }, "williamxu.net"),
  /*#__PURE__*/_createElementVNode("p", null, "This website is created with the goal of showcasing my professional experiences and personal projects, as well as some stuff for purely personal reasons. Here are some technolgies used to create this site:"),
  /*#__PURE__*/_createElementVNode("ul", { class: "list-disc list-inside my-1" }, [
    /*#__PURE__*/_createElementVNode("li", null, "frontend is created with Vue3 with TailwindCSS for styling. The frontend is hosted in a container in AWS. The domain and its certificate are created and registered on AWS also."),
    /*#__PURE__*/_createElementVNode("li", null, "backend utilizes the serverless architecture hosted on Microsoft Azure with Azure Functions. There are two separate backend services implemented, one using NodeJS and the other one using Python."),
    /*#__PURE__*/_createElementVNode("li", null, "MongoDB is the database solution of my choice here."),
    /*#__PURE__*/_createElementVNode("li", null, "User registartion and management; SSOs are implemented using Auth0.")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("button", {
          type: "button",
          class: "rounded bg-white px-3 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/stocks')))
        }, "Go to project")
      ]),
      _hoisted_4,
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("button", {
          type: "button",
          class: "rounded bg-white px-3 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/data')))
        }, "Go to project")
      ]),
      _hoisted_9,
      _hoisted_10
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("button", {
          type: "button",
          class: "rounded bg-white px-3 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/embark')))
        }, "Go to project")
      ]),
      _hoisted_14
    ]),
    _hoisted_15
  ], 64))
}